import { postApiGalaxyServer } from 'services';
import ApiClientManager from 'core/apiClient';
import { StateTransitionParams, StateTransitionResponse } from 'IntegrationModule/types';

export const transitionIntegrationStateApi = ({
  params,
  token,
  config = {},
}: BaseApiParams<StateTransitionParams>) => {
  const customHeaders =
    params.tenant && params.realmId
      ? ApiClientManager.buildUrlHeaders({ tenantName: params.tenant, realmId: params.realmId })
      : undefined;

  const { tenant: _tenant, realmId: _realmId, targetServiceId, ...bodyParams } = params;

  return postApiGalaxyServer<
    Omit<StateTransitionParams, 'tenant' | 'realmId' | 'targetServiceId'>,
    StateTransitionResponse
  >(
    `/integrations_api/integrations/${targetServiceId}/state`,
    bodyParams,
    { ...config, ...(customHeaders && { headers: customHeaders }) },
    token,
  );
};
